// extracted by mini-css-extract-plugin
module.exports = {"status":"InvoiceStatusPlate_status__26Ylw","icon":"InvoiceStatusPlate_icon__2gBIt"};